import type { StampInfo } from "./api.ts";

/**
 * Visual stamp card: a grid of stamp slots that fill as the customer buys
 * vapes, plus a "free vape ready" banner when a reward is available. Purely
 * presentational — progress comes from the server (StampInfo).
 */
export function StampCard({ stamps }: { stamps: StampInfo }) {
  const { count, size, freeVapeCredits, remaining } = stamps;
  const slots = Array.from({ length: size }, (_, i) => i < count);

  return (
    <div className="stampcard">
      {freeVapeCredits > 0 && (
        <div className="stampcard-reward">
          🎁 {freeVapeCredits === 1 ? "A free vape is ready" : `${freeVapeCredits} free vapes ready`}{" "}
          — redeem at checkout!
        </div>
      )}
      <div className="stampcard-grid">
        {slots.map((filled, i) => (
          <span
            key={i}
            className={filled ? "stamp-slot filled" : "stamp-slot"}
            aria-hidden="true"
          >
            {filled ? "💨" : i + 1}
          </span>
        ))}
      </div>
      <div className="stampcard-foot">
        <span>
          {count} / {size} stamps
        </span>
        {remaining > 0 && count > 0 && (
          <span className="stampcard-remaining">
            {remaining} more for a free vape
          </span>
        )}
      </div>
    </div>
  );
}
